import React from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { formatLocalString } from "../../utils/validation";
import { useLanguage } from "../../hooks/useLanguage";

function OrderComplete(){
  const {t} = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const orderData = location?.state?.order_data;
  const [searchParams] = useSearchParams();

  // 오늘 날짜 출력
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); 
    const date = String(today.getDate()).padStart(2, '0'); 
    return `${year}.${month}.${date}`;
  };

  // URL 파라미터 추출
  const orderSeq = searchParams.get('order_seq'); 
  const orderSeqNumber = orderSeq || location?.state?.order_seq;
  const settlePrice = searchParams.get('settleprice'); 
  const orderKind = location?.state?.order_kind;
  const orderType = orderKind || location?.state?.order_type;
  const orderStatus = location?.state?.order_status;
  
  // settlePrice가 유효한 숫자인지 확인하고 기본값 설정
  const validSettlePrice = settlePrice && !isNaN(settlePrice) ? Number(settlePrice) : 0;

  // 주문 상세 페이지로 이동하는 함수
  const handleOrderDetail = () => {
    if (!orderSeqNumber) {
      console.error("주문 번호가 유효하지 않습니다.");
      return;
    }

    navigate(`/myPage/order?type=${orderType}&orderNumber=${orderSeqNumber}`);
  };
  

  return(
    <div>
      <section className="order_inner auth_section min_height">
        <div className="order_detail_form">
          <div className="quo_title">
            { orderType === 'visit' ? 
              <h2>{t("rental_completed")}</h2>
            : 
              <h2>{t("order_completed")}</h2>
            }

          </div>
          <div className="flex-32 column">
            <div className="order_title">
              <h3>{t("order_info")}</h3>
            </div>
            <ul className="default_info_table v2">
              <li className="info_item">
                <div className="label">
                  <span>{t("order_date")}</span>
                </div>
                <div className="form_info">
                  <div className="info_detail">
                    {orderData?.payment_pending === "Y" ? orderData?.order_date : getTodayDate()}
                  </div>
                </div>
              </li>
              <li className="info_item">
                <div className="label">
                  <span>{t("order_number")}</span>
                </div>
                <div className="form_info">
                  <div className="info_detail">
                    {orderSeqNumber}
                  </div>
                </div>
              </li>
              <li className="info_item">
                <div className="label">
                  <span>{t("expected_payment_amount")}</span>
                </div>
                <div className="form_info">
                  <div className="info_detail">
                    {formatLocalString(orderData?.payment_pending === "Y" ? orderData?.price : validSettlePrice)}{t("price_txt")}
                    {orderStatus === "free" && <span style={{color:'#FF0000', marginLeft:'5px'}}>({t("unpaid")})</span>}
                  </div>
                </div>
              </li>
            </ul>
            <div className="submit_box_order">
              <button
                type="button"
                className="default_btn white lg"
                onClick={()=>navigate('/myPage')}
              >
                {t("go_to_main")}
              </button>
              <button
                type="button"
                className="default_btn black lg"
                onClick={handleOrderDetail}
              >
                {t("view_order_details")}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
};

export default OrderComplete; 